module.exports = __webpack_public_path__ + "static/Importation-678f072aa83c6ac02e2f7f823d3c9d71.gif";